import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
@Component({
  selector: 'app-our-colleges',
  standalone: true,
  imports: [CommonModule, MainMenuComponent, SubscribeComponent],
  templateUrl: '../templates/our-colleges.component.html'
})
export class OurCollegesComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly colleges: CollegeTableState[] = [
    {
      id: 'anantapuramu',
      label: 'ANANTAPURAMU',
      tabId: 'faq-one-tab',
      paneId: 'faq-one',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRG_r1VIxGkBKxfYtlXsGUF0OVQ4Nnx4H_Hqmi--mcv8VWclsnAoGQPQqhmi5pNkfNrRvunmdBWhVIC/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    },
    {
      id: 'dharmavaram',
      label: 'DHARMAVARAM',
      tabId: 'faq-two-tab',
      paneId: 'faq-two',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR2ONZgk8JPQX-qtCwB-Vre5Da3pfMXtNTUdQx04hs3oHCP85fr7DqrxB9rupJFr2DKUaIPL06Kvi-U/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    },
    {
      id: 'gooty',
      label: 'GOOTY',
      tabId: 'faq-three-tab',
      paneId: 'faq-three',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS0WCj8QHWn02Vd8uRJXftwW0fUa4fV-CYNZjFtwufcEL4uI4T0mWbMoVgb98e--ym_kEa9M8Fn89Ru/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    },
    {
      id: 'hindupur',
      label: 'HINDUPUR',
      tabId: 'faq-four-tab',
      paneId: 'faq-four',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRWa0N0XQn_zlUHF3W6-hLA8BkW-Zlf4V4krUoAYtVfPXpveqDd5nOykcyImbmO04DPQNaBJ6gRK6fh/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    },
    {
      id: 'kalyanadurgamu',
      label: 'KALYANADURGAMU',
      tabId: 'faq-five-tab',
      paneId: 'faq-five',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT4bwwCAVyLL2d-t-VMn5nxw5kX1-VpBlXod6HjYbNlEYg4xii0ub8rA160i8zmroHCcfZ-EnHky36B/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    },
    {
      id: 'kadiri',
      label: 'KADIRI',
      tabId: 'faq-six-tab',
      paneId: 'faq-six',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR03DojzVXfC0cYcx2AmexzMuKAu2zYdXImikcV48rXsE_TSiUT9KBf_XCkDYCoew0RomOoEWXlMz4r/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    },
    {
      id: 'mudigubba',
      label: 'MUDIGUBBA',
      tabId: 'faq-seven-tab',
      paneId: 'faq-seven',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQPrp_W0dfikmJ4AAHNqbww-BPlL74GcjyHJlPI_Jq9mpOEVWJo8MvIMHDhQOdgpjZHayNrkK-RAwIU/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    },
    {
      id: 'penukonda',
      label: 'PENUKONDA',
      tabId: 'faq-eight-tab',
      paneId: 'faq-eight',
      csvUrl: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTIf_HbJjOxEVEFwp8AmBs2qhnh65B383a5fNQxYWYiFY_tfHS_nrcBHi8DQS7kxaQSvoWrYo33Jjsd/pub?gid=0&single=true&output=csv',
      columns: [],
      rows: [],
      isLoading: false,
      errorMessage: '',
      hasLoaded: false
    }
  ];

  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngOnInit(): void {
    this.loadCollegeData(this.colleges[0].id);
  }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }

  onTabSelect(collegeId: string): void {
    this.loadCollegeData(collegeId);
  }

  trackByCollegeId(_: number, college: CollegeTableState): string {
    return college.id;
  }

  trackByColumnIndex(index: number): number {
    return index;
  }

  trackByRowIndex(index: number): number {
    return index;
  }

  getColumnKind(college: CollegeTableState, columnIndex: number): ColumnKind {
    const columnName = this.normalizeColumnName(this.getColumnName(college, columnIndex));

    const locationAliases = new Set([
      'location',
      'locationlink',
      'map',
      'maps',
      'address',
      'place'
    ]);

    const websiteAliases = new Set([
      'website',
      'websiteurl',
      'web',
      'url',
      'link',
      'site'
    ]);

    if (locationAliases.has(columnName)) {
      return 'location';
    }

    if (websiteAliases.has(columnName)) {
      return 'website';
    }

    return 'text';
  }

  getCellUrl(kind: ColumnKind, rawValue: string): string | null {
    if (!rawValue) {
      return null;
    }

    if (kind === 'location') {
      return this.toLocationUrl(rawValue);
    }

    if (kind === 'website') {
      return this.toWebsiteUrl(rawValue);
    }

    return null;
  }

  getLocationLabel(rawValue: string): string {
    return rawValue ? 'Open Location' : '';
  }

  private async loadCollegeData(collegeId: string): Promise<void> {
    const college = this.colleges.find((entry) => entry.id === collegeId);
    if (!college || college.hasLoaded || college.isLoading) {
      return;
    }

    college.isLoading = true;
    college.errorMessage = '';

    try {
      const response = await fetch(college.csvUrl);
      if (!response.ok) {
        throw new Error(`Failed to load ${college.label} data: ${response.status}`);
      }

      const csvText = await response.text();
      const parsed = this.parseCsv(csvText);

      if (!parsed.length) {
        college.columns = [];
        college.rows = [];
        college.hasLoaded = true;
        return;
      }

      const columns = parsed[0].map((header, index) => this.normalizeHeader(header, index));
      const rows = parsed.slice(1).map((row) =>
        columns.map((_, index) => this.normalizeCell(row[index]))
      );

      college.columns = columns;
      college.rows = rows.filter((row) => row.some((cell) => cell.length > 0));
      college.hasLoaded = true;
    } catch (error) {
      console.error(`Failed to load ${college.label} college data`, error);
      college.errorMessage = 'Unable to load college data right now.';
    } finally {
      college.isLoading = false;
    }
  }

  private parseCsv(csvText: string): string[][] {
    const rows: string[][] = [];
    let currentRow: string[] = [];
    let currentCell = '';
    let inQuotes = false;

    for (let index = 0; index < csvText.length; index++) {
      const char = csvText[index];
      const nextChar = csvText[index + 1];

      if (char === '"') {
        if (inQuotes && nextChar === '"') {
          currentCell += '"';
          index++;
        } else {
          inQuotes = !inQuotes;
        }
        continue;
      }

      if (char === ',' && !inQuotes) {
        currentRow.push(this.normalizeCell(currentCell));
        currentCell = '';
        continue;
      }

      if ((char === '\n' || char === '\r') && !inQuotes) {
        if (char === '\r' && nextChar === '\n') {
          index++;
        }

        currentRow.push(this.normalizeCell(currentCell));
        currentCell = '';

        if (currentRow.some((cell) => cell.length > 0)) {
          rows.push(currentRow);
        }

        currentRow = [];
        continue;
      }

      currentCell += char;
    }

    currentRow.push(this.normalizeCell(currentCell));
    if (currentRow.some((cell) => cell.length > 0)) {
      rows.push(currentRow);
    }

    return rows;
  }

  private normalizeHeader(value: string | undefined, index: number): string {
    const normalized = this.normalizeCell(value);
    return normalized || `Column ${index + 1}`;
  }

  private getColumnName(college: CollegeTableState, columnIndex: number): string {
    return college.columns[columnIndex]?.trim() ?? '';
  }

  private normalizeColumnName(name: string): string {
    return name.toLowerCase().replace(/[\s_-]+/g, '');
  }

  private toLocationUrl(rawValue: string): string | null {
    const value = this.normalizeCell(rawValue);
    if (!value) {
      return null;
    }

    if (this.hasAbsoluteProtocol(value)) {
      return value;
    }

    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(value)}`;
  }

  private toWebsiteUrl(rawValue: string): string | null {
    const value = this.normalizeCell(rawValue);
    if (!value) {
      return null;
    }

    if (this.hasAbsoluteProtocol(value)) {
      return value;
    }

    if (value.includes(' ')) {
      return null;
    }

    return `https://${value}`;
  }

  private hasAbsoluteProtocol(value: string): boolean {
    return /^https?:\/\//i.test(value);
  }

  private normalizeCell(value: string | undefined): string {
    return value == null ? '' : String(value).trim();
  }
}

type ColumnKind = 'location' | 'website' | 'text';

interface CollegeTableState {
  id: string;
  label: string;
  tabId: string;
  paneId: string;
  csvUrl: string;
  columns: string[];
  rows: string[][];
  isLoading: boolean;
  errorMessage: string;
  hasLoaded: boolean;
}

